import React, { useState } from 'react';
import Button from '../../components/shared/buttons/button';
import { AiOutlineEye } from "react-icons/ai";
import Datatable from '../../components/shared/datatable/Datatable';
import { useNavigate } from 'react-router';
import { useGetUsersQuery, useEnableReviewMutation } from '../../app/userApi/userApi';
import { formatDateTimeToUK } from '../../helpers/Utils';
import { Form, Spinner } from 'react-bootstrap';

const UsersData = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [loadingToggles, setLoadingToggles] = useState({}); // 👈 New state

  const { data: surveyList, isLoading } = useGetUsersQuery({ page, limit: 10, search });
  const [enableUser] = useEnableReviewMutation(); // no need to destructure isLoading now

  const navigate = useNavigate();

  const onPageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1); // Reset to first page on new search
  };

  const handleToggle = async (userId) => {
    setLoadingToggles((prev) => ({ ...prev, [userId]: true }));

    try {
      await enableUser(userId).unwrap();
    } catch (error) {
      console.error("Toggle failed:", error);
    } finally {
      setLoadingToggles((prev) => ({ ...prev, [userId]: false }));
    }
  };

  const columns = [
    { label: "Name", accessor: "contact_name" },
    { label: "Phone", accessor: "phone" },
    { label: "Weekly app Usage", accessor: "app_usage_time_formatted" },
    {
      label: "Survey created at",
      accessor: "createdAt",
      cell: ({ row }) => <>{formatDateTimeToUK(row?.createdAt)}</>,
    },
    {
      label: "Last login",
      accessor: "createdAt",
      cell: ({ row }) => <>{row?.last_login ? formatDateTimeToUK(row?.last_login) : "---"}</>,
    },
    {
      label: "View",
      accessor: "Action",
      cell: ({ row }) => (
        <div className="d-flex gap-2 align-items-center">
          <Button
            icon={<AiOutlineEye size={24} />}
            className="borderedBtn"
            size="xs"
            onClick={() => {
              navigate(`/users/user-details/${row?._id}`, {
                state: { userName: row?.contact_name, userEmail: row?.email },
              });
            }}
          />
        </div>
      ),
    },
    {
      label: 'Enable Review',
      accessor: 'action',
      cell: ({ row }) => {
        const isLoadingToggle = !!loadingToggles[row._id];

        return (
          <Form.Check
            className='cursor-pointer'
            type='switch'
            id={`user-toggle-${row._id}`}
            label={
              isLoadingToggle ? (
                <Spinner animation="border" size="sm" />
              ) : (
                row?.reviews_enabled ? 'Enable' : 'Disable'
              )
            }
            checked={row?.reviews_enabled}
            disabled={isLoadingToggle}
            onChange={() => handleToggle(row._id)}
          />
        );
      },
    },
  ];

  return (
    <Datatable
      isLoading={isLoading}
      tableData={surveyList?.data}
      columns={columns}
      page={page}
      onPageChange={onPageChange}
      showPegination={true}
      showFilter={true}
      onFilterSearch={handleSearch}
    />
  );
};

export default UsersData;
